import React, { useEffect, useRef, useState } from "react";
import { Hero } from "../components/Hero";
import { StickyOfferBar } from "../components/StickyOfferBar";
import { StatsStrip } from "../components/StatsStrip";
import { ProblemSection } from "../components/ProblemSection";
import { SolutionSection } from "../components/SolutionSection";
import { WorkshopsSection } from "../components/WorkshopsSection";
import { SampleCarousel } from "../components/SampleCarousel";
import { BonusesSection } from "../components/BonusesSection";
import { OfferSection } from "../components/OfferSection";
import { FaqSection } from "../components/FaqSection";
import { ClosingSection } from "../components/ClosingSection";
import { SiteFooter } from "../components/SiteFooter";
export function Landing() {
  const heroRef = useRef<HTMLDivElement>(null);
  const offerRef = useRef<HTMLDivElement>(null);
  const [pastHero, setPastHero] = useState(false);
  const [offerVisible, setOfferVisible] = useState(false);
  useEffect(() => {
    const heroObserver = new IntersectionObserver(([entry]) => setPastHero(!entry.isIntersecting));
    const offerObserver = new IntersectionObserver(([entry]) => setOfferVisible(entry.isIntersecting), {
      threshold: 0.15
    });
    if (heroRef.current) heroObserver.observe(heroRef.current);
    if (offerRef.current) offerObserver.observe(offerRef.current);
    return () => {
      heroObserver.disconnect();
      offerObserver.disconnect();
    };
  }, []);
  return <div className="min-h-screen w-full overflow-x-hidden bg-white font-sans text-ink antialiased" data-id="element-198" data-mp="gz6kdy25cigq">
      <StickyOfferBar visible={pastHero && !offerVisible} data-id="element-199" data-mp="c7y5wnlym6wp" />
      <main data-id="element-200" data-mp="c63m5cmfcku7">
        <div ref={heroRef} data-id="element-201" data-mp="c5vafo21flkl">
          <Hero data-id="element-202" data-mp="79n0qq6m0kkt" />
        </div>
        <StatsStrip data-id="element-203" data-mp="78bvsn1fh6s4" />
        <ProblemSection data-id="element-204" data-mp="770s0n7zfz10" />
        <SolutionSection data-id="element-205" data-mp="14oipalqfy4d8" />
        <WorkshopsSection data-id="element-206" data-mp="14or1ebeqp5nd" />
        <SampleCarousel data-id="element-207" data-mp="14q24e90d29df" />
        <BonusesSection data-id="element-208" data-mp="14qbxw6km6ynv" />
        <div ref={offerRef} data-id="element-209" data-mp="zy28qsrbq2mn">
          <OfferSection data-id="element-210" data-mp="zwr5qv5pcywl" />
        </div>
        <FaqSection data-id="element-211" data-mp="zvpno6q9rc5d" />
        <ClosingSection data-id="element-212" data-mp="1iuaxhse6iksx" />
      </main>
      <SiteFooter data-id="element-213" data-mp="1ivc85vra95a4" />
    </div>;
}